<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        ></v-progress-circular>
        <v-form v-if="!loading" @submit.prevent="updateGroup">
          <v-card max-width="650px" width="650px" v-if="!loading">
            <v-card-title>
              <span class="headline">{{
                $t("users.groupsEdit.editBrand")
              }}</span>
            </v-card-title>
            <v-container class="px-6">
              <v-row no-gutters class="mt-1">
                <v-col cols="12" class="mb-0 pb-0 pl-2 pr-3">
                  <v-text-field
                    v-model="editedItem.name"
                    :label="$t('users.groupsEdit.brandName')"
                    color="primary"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="mb-0 pb-0 px-0 mx-0">
                  <v-card-actions class="mb-0 pb-0 px-0 mx-0">
                    <v-btn color="red" text @click="deleteDialog = true">{{
                      $t("users.groupsEdit.delete")
                    }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="close">{{
                      $t("users.groupsEdit.cancel")
                    }}</v-btn>
                    <v-btn color="primary" text @click="updateGroup">{{
                      $t("users.groupsEdit.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-form>
      </v-layout>
      <delete-dialog
        :dialog="deleteDialog"
        :item="editedItem.name"
        @agree="removeGroup"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import snackbar from "@/utils/snackbar.js";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";

export default {
  components: {
    DeleteDialog,
  },
  data: () => ({
    tab: null,
    loading: true,
    userToDelete: {},
    deleteDialog: false,
    valid: false,
    email: "",
    role: null,
    roleOptions: [],
    emailRules: [],
    cancelDialog: {
      active: false,
    },
    editedItem: {
      name: "",
      roles: [],
    },
  }),

  created() {
    this.setInitialData();
    this.loadGroup();
  },

  methods: {
    setInitialData() {
      this.emailRules = [
        (v) => !!v || this.$t("users.groupsEdit.eMailIsRequired"),
        (v) =>
          /[^@]+@[^.]+\..*/.test(v) ||
          this.$t("users.groupsEdit.eMailMustBeValid"),
      ];
      this.cancelDialog = {
        active: false,
        title: this.$t("users.groupsEdit.removeUser"),
        text: this.$t("users.groupsEdit.areYouSureYouWantToRemoveUser"),
      };
    },
    loadGroup() {
      this.loading = true;
      api.getGroup(this.$route.params.brandId).then((resp) => {
        this.editedItem = resp.data;
        this.roleOptions = resp.data.roles.map((item) => {
          return { name: item.name, uuid: item.uuid };
        });
        this.loading = false;
      });
    },
    removeGroup(agreed) {
      if (agreed) {
        api
          .deleteGroup(this.$route.params.brandId)
          .then((resp) => {
            snackbar.success(
              this.$t("utils.snackbar.success.successfullyDeleted")
            );
            this.close();
          })
          .catch((err) => {
            if (typeof err.response.data.error !== "undefined") {
              snackbar.error(err.response.data.error);
            } else {
              snackbar.error();
            }
          });
      }
      this.deleteDialog = false;
    },

    close() {
      this.$router.push({
        name: "brands",
      });
    },
    updateGroup() {
      api
        .updateGroup(this.$route.params.brandId, this.editedItem)
        .then((resp) => {
          this.close();
          snackbar.success(this.$t("utils.snackbar.success.successfullySaved"));
        });
    },
  },
};
</script>
